import React from "react";
import SearchBox from "components/SearchBox";
import Box from "components/UI/Box";
import Button from "components/UI/Button";
import { toast } from "react-toastify";
import moment from "moment";
import axios from "axios";
import { API_URL, ERROR_HANDLE, DOWNLOAD } from "config/constants";
import theme from "../../../../Theme/theme";
import AddTrainers from "../Modals/AddTrainers";
import { FilePicker } from "react-file-picker";
import EditTrainer from "../Modals/EditTrainer";
import { Constants } from "../../../../common/constants"
import SlideSwitch from "components/SlideSwitch";

const restricted_access = localStorage.getItem("restricted_access");

class Trainers extends React.Component {
  componentDidMount() {
    const access_token = localStorage.getItem("access_token");
    this.getGyms(access_token)
    this.getTrainers(access_token);
    this.getTags(access_token);
  }

  state = {
    trainers: [],
    filteredTrainers: [],
    showFilter: false,
    filters: {
      age: null,
      minutes: null,
      gender: null
    },
    currentPage: 0,
    rowCount: 10,
    showAddModal: false,
    showEdit: false,
    order: true
  };

  toggledTrainerId = null;
  hideStatusTrainerId = null;

  getGyms(access_token) {
    axios.get(`${API_URL}/admin/gyms/basicDetails?pt_enabled=true`, {
      headers: {
        "x-access-token": access_token
      }
    }).then(res=>{
      this.setState({
        gyms: res.data.map(gym => ({ value: gym.gym_id, label: gym.gym_name + ", " +gym.city }))
      })
    })
  }

  getTrainers(access_token) {
    const toastId = toast("Fetching Trainers...");
    this.setState({
      loading : true
    })
    axios
      .get(`${API_URL}/trainer`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        this.setState({
          loading : false
        })
        if (!res.error) {
          toast.dismiss(toastId);
          res.data.sort((a, b) => {
            return new Date(b.updatedAt) - new Date(a.updatedAt);
          })
          this.setState({
            ...this.state,
            trainers: res.data,
            filteredTrainers: res.data
          });
        } else {
          if (res.error === 'Invalid Auth Token') {
            window.location.assign("/");
          }
        }
      })
      .catch(err => {
        this.setState({
          loading : false
        })
        ERROR_HANDLE(err);
      });
  }


  getTags(access_token) {
    this.setState({
      loading : true
    })
    axios
      .get(`${API_URL}/tags`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        this.setState({
          loading : false
        })
        if (!res.error) {
          this.setState({
            tags: res.data.map(tag => ({ value: tag.id, label: tag.name }))
          })
        } else {
          if (res.error === 'Invalid Auth Token') {
            window.location.assign("/");
          }
        }
      })
      .catch(err => {
        this.setState({
          loading : false
        })
        ERROR_HANDLE(err);
      });
  }

  filter = () => {
    let { filters, filteredTrainers } = this.state;
    if (filters.gender)
      filteredTrainers = filteredTrainers.filter(trainer => {
        let gender = trainer.gender
          ? trainer.gender.toLowerCase()[0] === "f"
            ? "Female"
            : "Male"
          : " ";

        return gender === filters.gender;
      });

    if (filters.age)
      filteredTrainers = filteredTrainers.filter(trainer => {
        const age = moment().diff(trainer.birthday, "years") || 0;
        return age > filters.age.min && age < filters.age.max;
      });

    if (filters.minutes)
      filteredTrainers = filteredTrainers.filter(trainer => {
        let { min, max } = filters.minutes;
        let minutes = parseInt(trainer.total_minutes, 10) / 60000;
        return minutes > min && minutes < max;
      });

    return filteredTrainers;
  };

  searchHandler = e => {
    const filteredTrainers = this.state.trainers.filter(
      trainer => trainer.name.toLowerCase().search(e.target.value.toLowerCase()) > -1
    );
    this.setState({ ...this.state, filteredTrainers, currentPage: 0 });
  };

  searchHandler = e => {
    const filteredTrainers = this.state.trainers.filter(
      trainer => trainer.name.toLowerCase().search(e.target.value.toLowerCase()) > -1
    );
    this.setState({ ...this.state, filteredTrainers, currentPage: 0 });
  };

  bulkUpload = (file)=> {
    const access_token = localStorage.getItem("access_token");

    const data = new FormData();
        data.append("csv", file);

    axios.post(`${API_URL}/trainer/register_bulk_csv`, data, {
      headers: {
        "x-access-token": access_token
      }
    }).then(res=> {
      const access_token = localStorage.getItem("access_token");
      this.getTrainers(access_token);
    }).catch(error=> {
      ERROR_HANDLE(error);
    })
  }

  exportTrainers = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Trainer Data...");
    axios
      .get(`${API_URL}/report/trainers`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "trainers.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  exportVirtualBookings = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Virtual training bookings data...");
    axios
      .get(`${API_URL}/report/virtual_bookings`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "virtual_bookings.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  exportVirtualSessions = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Virtual training sessions Data...");
    axios
      .get(`${API_URL}/report/virtual_sessions`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "virtual_sessions.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  triggerVirtualGyms = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Enabling Vitual Gym...");
    axios
      .post(`${API_URL}/gyms/trigger/virtualGym`, {} ,{
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        if (res.status == 200) toast.success("Successfully enabled virtual gym", { autoClose: Constants.TOAST_TIME_OUT });
        else toast.error(res.error, { autoClose: Constants.TOAST_TIME_OUT });
        toast.dismiss(toastId);
      })
      .catch(err => {
      ERROR_HANDLE(err);
      });
  }

  handlePrivateTrainers = (activeState) => {
    if (this.toggledTrainerId) {
      this.updateToggleState(this.toggledTrainerId);
      this.updateShowInAppTrainer(activeState)
    }
  };

  updateToggleState(toggledTrainerId) {
    this.setState(prevState => ({
      filteredTrainers: prevState.filteredTrainers.map(
        trainers => trainers.id === toggledTrainerId ? { ...trainers, is_private: !trainers.is_private } : trainers
      )
    }))
  }

  handleHideFromChatTrainer = (activeState) => {
    if (this.hideStatusTrainerId) {
      this.updateHideFromChatToggleState(this.hideStatusTrainerId);
      this.updateHideFromChatStatusTrainer(activeState)
    }
  };

  updateHideFromChatToggleState(hideStatusTrainerId) {
    this.setState(prevState => ({
      filteredTrainers: prevState.filteredTrainers.map(
        trainers => trainers.id === hideStatusTrainerId ? { ...trainers, hide_from_chat: !trainers.hide_from_chat } : trainers
      )
    }))
  }

  updateHideFromChatStatusTrainer = (activeState) => {
    var toastId = toast("Updating details...")
    var trainer = {
      hide_from_chat: activeState
    }
    axios.put(`${API_URL}/trainer/admin/chat/hide_trainer/${this.hideStatusTrainerId}`,
      trainer,
      {
        headers: {
          "x-access-token": localStorage.getItem("access_token")
        }
      }).then((res) => {
        toast.dismiss(toastId);
        toast("Status Changed Successfully", { autoClose: 1500 });
        this.hideStatusTrainerId = null;
      }).catch((e) => {
        this.updateHideFromChatToggleState(this.hideStatusTrainerId);
        this.hideStatusTrainerId = null;
        toast.dismiss(toastId);
        toastId = toast("Updated failed " + e.message);
        setTimeout(() => {
          toast.dismiss(toastId);
        }, 2000);
      })
  }

  updateShowInAppTrainer = (activeState) => {
    var toastId = toast("Updating details...")
    var trainer = {
      is_private: activeState
    }
    axios.put(`${API_URL}/trainer/profile?trainerId=${this.toggledTrainerId}`,
      trainer,
      {
        headers: {
          "x-access-token": localStorage.getItem("access_token")
        }
      }).then((res) => {
        toast.dismiss(toastId);
        toast("Status Changed Successfully", { autoClose: 1500 });
        this.toggledTrainerId = null;
      }).catch((e) => {
        this.updateToggleState(this.toggledTrainerId);
        this.toggledTrainerId = null;
        toast.dismiss(toastId);
        toastId = toast("Updated failed " + e.message);
        setTimeout(() => {
          toast.dismiss(toastId);
        }, 2000);
      })
  }

  render() {
    return (
      <div style={style.wrapper}>
        <SearchBox onChange={this.searchHandler}/>
        <div style={style.buttonsContainer}>
          {restricted_access == "false" && <Button type="primary" style={style.button} onClick={(e) => {
            e.stopPropagation()
            this.setState({ showAddModal: true })
          }}>Add Trainers</Button>}
          <FilePicker onChange={this.bulkUpload}>
            <Button type="primary" style={style.button} onClick={(e) => {
              e.stopPropagation()
            }}>
              Upload Trainer List
            </Button>
          </FilePicker>
          {restricted_access == "false" &&
            <div> <Button type="primary" style={style.button} onClick={(e) => {
              e.stopPropagation()
              this.exportTrainers();
            }}>Export Trainers</Button>
              <Button type="primary" style={style.button} onClick={(e) => {
                e.stopPropagation()
                this.exportVirtualBookings();
              }}>Export VT Bookings</Button>
              <Button type="primary" style={style.button} onClick={(e) => {
                e.stopPropagation()
                this.exportVirtualSessions();
              }}>Export VT Sessions</Button>
              <Button type="primary" style={style.button} onClick={(e) => {
                e.stopPropagation()
                this.triggerVirtualGyms();
              }}>Enable Virtual Gym</Button>
            </div>}
        </div>
        <Box style={{...style.box, minHeight: 100, minWidth: 1000, padding:0, marginBottom: 50}} outline>
          {this.header()}
          {this.state.filteredTrainers.length > 0 && this.trainerRows(this.state.filteredTrainers)}
          {this.state.filteredTrainers.length === 0 && !this.state.loading && 
            <div style={{marginTop:15, marginBottom:15, fontSize: 24, color:'#00b4d2'}}>No trainers</div>}
        </Box>
        {
          this.state.showAddModal &&
          <AddTrainers gyms={this.state.gyms} close={() => {
            this.setState({
              showAddModal: false
            })
            const access_token = localStorage.getItem("access_token");
            this.getTrainers(access_token);
          }} />
        }
        {
          this.state.showEdit && 
          <EditTrainer trainer={this.state.selectedTrainer} gyms={this.state.gyms} tags={this.state.tags} close={()=>{
            this.state.trainers.sort((a, b) => {
              return new Date(b.updatedAt) - new Date(a.updatedAt);
            })
            this.setState({
              showEdit : false,
            })
          }}/>
        }
        </div>
    );
  }

  trainerRows = trainers => {
    return trainers.map((trainer, i) => {
      const itemWrapper = trainer.is_session_active ? { ...style.itemWrapper, ...{ background: theme.color.mediumPrimaryBlue, marginTop: -10, marginBottom: -10 } } : style.itemWrapper
      const itemStyle = trainer.is_session_active ? { ...style.item, ...{ color: theme.color.white, fontWeight: theme.fontWeight.bold } } : style.item
      const persistent = (
        <div key={trainer.email}>
          <div style={{height:1, backgroundColor: "#b5b5b6"}}></div>
          <div style={itemWrapper}>
            <p style={itemStyle, {flex: 1}}>{trainer.name}</p>
            <p style={itemStyle, {flex: 2}}>{trainer.email}</p>
            <p style={itemStyle, { flex: 1 }}>$ {parseFloat(trainer.rate).toFixed(2)}</p>
            <p style={itemStyle, { flex: 3 }}>{getGym(trainer.gyms)}</p>
            <SlideSwitch
              style={style.sliderStyle}
              checked={trainer.is_private}
              onClick={() => {
                this.toggledTrainerId = trainer.id
                this.handlePrivateTrainers(!trainer.is_private)
              }}
            />
            <p style={itemStyle, { flex: 2 }}>{trainer.affiliated_to ? trainer.affiliated_to.name : "--"}</p>
            <SlideSwitch
              style={style.sliderStyle}
              checked={trainer.hide_from_chat}
              onClick={() => {
                this.hideStatusTrainerId = trainer.id
                this.handleHideFromChatTrainer(!trainer.hide_from_chat)
              }}
            />
            <div style={{display:'flex', flex: 0.75}}>
              <Button type="holo" holo style={style.editButton} onClick={(e) => {
                this.setState({
                  showEdit: true,
                  selectedTrainer: trainer
                })
              }}>Edit</Button>
            </div>
          </div>
        </div >
      );
  
      return  persistent;
    });
  }
  header = () => {
    const { sort, order } = this.state;
    return (<div style={style.titleWrapper}>
      <div style={{...style.titleItem, flex: 1}} onClick={()=>this.sortByString('name')}>
        <p>Name</p>
        <div style={{marginLeft:'10px'}}>
          <p style={{margin:0, fontSize:'10px'}}>{sort === 'name' && !order ? '\u25B2' : '\u25B3'}</p>
          <p style={{margin:0, fontSize:'10px'}}>{sort === 'name' && order ? '\u25BC' : '\u25BD'}</p>
        </div>
      </div>
      <div style={{ ...style.titleItem, flex: 2 }} onClick={() => this.sortByString('email')}>
        <p>Email</p>
        <div style={{marginLeft:'10px'}}>
          <p style={{margin:0, fontSize:'10px'}}>{sort === 'email' && !order ? '\u25B2' : '\u25B3'}</p>
          <p style={{margin:0, fontSize:'10px'}}>{sort === 'email' && order ? '\u25BC' : '\u25BD'}</p>
        </div>
      </div>
      <div style={{ ...style.titleItem, flex: 1 }} onClick={() => this.sortByNumber('rate')}>
        <p>Rate</p>
        <div style={{marginLeft:'10px'}}>
          <p style={{margin:0, fontSize:'10px'}}>{sort === 'rate' && !order ? '\u25B2' : '\u25B3'}</p>
          <p style={{margin:0, fontSize:'10px'}}>{sort === 'rate' && order ? '\u25BC' : '\u25BD'}</p>
        </div>
      </div>
      <p style={{...style.titleItem, flex: 3}}>Assc. Gyms</p>
      <p style={{ ...style.titleItem, flex: 1 }}>Private</p>
      <p style={{ ...style.titleItem, flex: 2 }}>Brand</p>
      <p style={{ ...style.titleItem, flex: 1 }}>Hide From Chat</p>
      <p style={{...style.titleItem, flex: 0.75}}></p>
    </div>)
  }

  sortByString = (param) => {
    var trainers = this.state.trainers
    trainers.sort((a, b) => {
      if(a[param] < b[param]) { return this.state.order ? -1 : 1}
      if(a[param] > b[param]) { return this.state.order ? 1 : -1 }
      return 0;
    })
    this.setState({
      trainers : trainers,
      order: !this.state.order,
      sort: param
    })
  }

  sortByNumber = (param) => {
    var trainers = this.state.trainers
    trainers.sort((a, b)=> ((a[param] - b[param]) * (this.state.order ? 1 : -1)))
    this.setState({
      trainers : trainers,
      order: !this.state.order,
      sort: param
    })
  }
}
export default Trainers;


const style = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center"
  },
  filterIconWrapper: {
    margin: "0px 20px",
    backgroundColor: "#00b4d2",
    borderRadius: "100%",
    padding: "15px",
    cursor: "pointer"
  },
  filterIcon: {
    width: "30px",
    height: "30px"
  },
  box: {
    width: "1400px"
  },
  titleWrapper: {
    backgroundColor: "#00b4d2",
    display: "flex",
    paddingLeft: "3px",
    borderTopLeftRadius: "38px",
    borderTopRightRadius: "38px"
  },
  titleItem: {
    fontSize: "20px",
    color: "white",
    fontWeight: 'bold',
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    justifyContent:'center'
  },
  filtersWrapper: {
    display: "flex",
    justifyContent: "center"
  },
  exportButton: {
    width: "150px",
    height: "40px",
    fontSize: "15px"
  },
  button: {
    width: "220px",
    height: "50px",
    fontSize: "18px",
    marginLeft: "15px"
  },
  itemWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    paddingLeft: "3px"
  },
  editButton: {
    width: "77px",
    height: "29px",
    fontSize: "16px",
    fontWeight: theme.fontWeight.regular,
    color: theme.color.thickGrey
  },
  collapsableWrapper: {
    backgroundColor: "#000",
    color: "#b5b5b6",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 30px"
  },
  collapseLabel: {
    fontSize: "10px"
  },
  collapseItem: {
    margin: "0px"
  },
  profileImageWrapper: {
    objectFit: "cover",
    borderRadius: "100%",
    flex: 0.5
  },
  longItem: {
    flex: "1.6"
  },
  profileImage: {
    borderRadius: "100%"
  },
  buttonsContainer : {
    display:'flex',
    flexDirection: 'row', 
    marginBottom:'40px'
  },
  sliderStyle: {
    alignSelf: "center",
    flex: 1,
    marginTop: 5,
    minWidth: 75
  },
};

const getGym = (gyms) => {
  return gyms.length == 0 ? "" : gyms.length > 1 ? gyms[0].gym_name + ", " + gyms[0].city + " and " + (gyms.length - 1) +  " more" : gyms[0].gym_name + ", " + gyms[0].city
}